import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Tabs } from 'antd';
import { useSearchParams } from 'react-router-dom';
import Header from 'components/Header';
import { PageContainer } from 'ui/styled';
import useTeamHeaderTitle from '../hooks/useTeamHeaderTitle';
import TicketTypes from './TicketTypes';
import TicketFlags from './TicketFlags';
import Deliverables from './Deliverables';
import ArticleCategories from './ArticleCategories';
import ChatTemplates from './ChatTemplates';
import Surveys from './Surveys';
var DEFAULT_TAB = 'ticket_types';
var ITEMS = [
    {
        key: 'ticket_types',
        label: 'Ticket Types',
        children: _jsx(TicketTypes, {})
    },
    {
        key: 'ticket_flags',
        label: 'Ticket Flags',
        children: _jsx(TicketFlags, {})
    },
    {
        key: 'deliverables',
        label: 'Deliverables',
        children: _jsx(Deliverables, {})
    },
    {
        key: 'article_categories',
        label: 'Article Categories',
        children: _jsx(ArticleCategories, {})
    },
    {
        key: 'chat_templates',
        label: 'Chat Templates',
        children: _jsx(ChatTemplates, {})
    },
    {
        key: 'surveys',
        label: 'Surveys',
        children: _jsx(Surveys, {})
    }
];
var TeamContent = function () {
    var _a, _b;
    var _c = useTeamHeaderTitle('Team Content Availability'), title = _c.title, loading = _c.loading;
    var _d = useSearchParams(), searchParams = _d[0], setSearchParams = _d[1];
    var tabParam = searchParams.get('tab');
    var activeTab = (_b = (_a = ITEMS.find(function (_a) {
        var key = _a.key;
        return key === tabParam;
    })) === null || _a === void 0 ? void 0 : _a.key) !== null && _b !== void 0 ? _b : DEFAULT_TAB;
    var handleTabChange = function (key) { return setSearchParams({ tab: key }); };
    return (_jsxs(_Fragment, { children: [_jsx(Header, { title: title, loading: loading }), _jsx(PageContainer, { padding: "16px", children: _jsx(Tabs, { activeKey: activeTab, onChange: handleTabChange, items: ITEMS }) })] }));
};
export default TeamContent;
